import { ExperimentOutlined } from '@ant-design/icons'
import { Stack, Typography } from '@sureco/design-system'
import React from 'react'

interface DemoBannerProps {
  /** Descriptive line shown beneath the heading. */
  description?: string
}

/**
 * Full-width amber banner used on every demo customer page to make it
 * immediately clear that the user is working in a demo environment.
 *
 * Place it as the first child inside the <Page> content area.
 */
export default function DemoBanner({ description }: DemoBannerProps) {
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #fff7e6 0%, #fff1d6 100%)',
        border: '1px solid #ffd591',
        borderLeft: '5px solid #fa8c16',
        borderRadius: 8,
        padding: '12px 20px',
        marginBottom: 24,
      }}
    >
      <Stack direction="row" space={10} align="center">
        <ExperimentOutlined
          style={{ color: '#fa8c16', fontSize: 20, flexShrink: 0 }}
        />
        <Stack space={2}>
          <Typography
            size={14}
            style={{ fontWeight: 700, color: '#873800', letterSpacing: 0.3 }}
          >
            DEMO COMPANY
          </Typography>
          <Typography size={13} style={{ color: '#ad4e00' }}>
            {description ??
              'You are creating a demo company for a sales demonstration.'}
          </Typography>
        </Stack>
      </Stack>
    </div>
  )
}
